import "swiper/css";
import "swiper/css/navigation";

import {
  NewsSection,
  HeroSection,
  AboutSection,
  Photo,
} from "../../components/Galary";
import { imgg1, imgg12, imgg21, imgg28, imgg7 } from "../../assets";

export default function Gallery() {
  const images = [imgg1, imgg7, imgg12, imgg21, imgg28];

  return (
    <div className="portfolio-containerr">
      <HeroSection images={images} title="The Gaza" subtitle="Photo Diaries" />
      <AboutSection />
      <Photo />
      <NewsSection />
    </div>
  );
}
